<script>
	// Partials
	import DesktopBetRow from '@/Partials/User/_DesktopBetRow.svelte';
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
	export let bets;
	export let manualResult = undefined;
</script>

<div class="w-full mt-2 bg-light overflow-x-auto">
	<div class="table w-full">
		<div class="table-header-group">
			<div class="table-row text-sm text-center bg-grey text-light">
				<div class="sticky top-0 table-cell py-2 pl-2 text-left bg-grey text-light w-30">Ticket</div>
				<div class="sticky top-0 table-cell py-2 bg-grey text-light w-56">Type</div>
				<div class="sticky top-0 table-cell px-4 py-2 text-left bg-grey text-light">Description</div>
				<div class="sticky top-0 table-cell px-4 py-2 text-left bg-grey text-light">Selection</div>
				<div class="sticky top-0 table-cell py-2 bg-grey text-light w-64">Bet</div>
				<div class="sticky top-0 table-cell py-2 bg-grey text-light">Status</div>
				<div class="sticky top-0 table-cell py-2 bg-grey text-light w-px">Return</div>
				<div class="sticky top-0 table-cell py-2 bg-grey text-light w-px text-nowrap">Net Win</div>
				<div class="sticky top-0 table-cell py-2 bg-grey text-light" />
			</div>
		</div>
		<div class="table-row-group">
			{#if !bets.count()}
				<div class="table-row text-sm text-center">
					<div class="table-cell px-2 py-2 text-left border-b">No betting history</div>
				</div>
			{:else}
				{#each bets.all() as bet, index (bet.id)}
					<DesktopBetRow {bet} {index} {manualResult} on:updated={() => dispatch('updated')} />
				{/each}
			{/if}
		</div>
	</div>
</div>
